// window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
  // window.Popper = require('popper.js').default;
  window.$ = window.jQuery = require('jquery');
  require('slick-carousel');
  require('jquery-validation/dist/jquery.validate');
  window.axios = require('axios');

  // require('bootstrap');
} catch (e) {
}


(function ($) {
  /* fixed header */
  $(window).scroll(function () {
    var menu = $("header > nav");
    scroll = $(window).scrollTop();

    if (scroll >= 160) {
      menu.addClass('fixed');
    } else {
      menu.removeClass('fixed');
    }
  });


  $(document).on('keyup', 'form[name="recall_service"] input', function () {
    if (this.value.length > 1) {
      if ($(this).hasClass('error')) {
        $(this).removeClass('error');
      }

      if ($(this).parent().find('span[class^="error"]').length > 0) {
        $(this).parent().find('span[class^="error"]').remove();
      }
    }
  });

  $(document).on('change', 'form[name="recall_service"] select', function () {
    if (this.value.length > 1) {
      if ($(this).hasClass('error')) {
        $(this).removeClass('error');
      }

      if ($(this).parent().find('span[class^="error"]').length > 0) {
        $(this).parent().find('span[class^="error"]').remove();
      }
    }
  });

  $(document).on('keyup', 'form[name="contact-form"] input', function () {
    if (this.value.length > 1) {
      if ($(this).hasClass('error')) {
        $(this).removeClass('error');
      }

      if ($(this).parent().find('span[class^="error"]').length > 0) {
        $(this).parent().find('span[class^="error"]').remove();
      }
    }
  });

  /* jquery validation */
  jQuery.validator.setDefaults({
    errorElement: 'div',
    errorPlacement: function (error, element) {
      error.addClass('invalid-feedback');
      element.closest('.form-group').append(error);
    },
    highlight: function (element, errorClass, validClass) {
      $(element).addClass('is-invalid');
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).removeClass('is-invalid');
    }
  });
  $(document).on('click', '.nav--toggle, .sidebar-box', function () {
    let body = $('body');
    if (typeof body.attr('data-nav-toggled') !== undefined && body.attr('data-nav-toggled') !== false) {
      if (body.attr('data-nav-toggled') === 'true') {
        body.attr('data-nav-toggled', 'false')
      } else {
        body.attr('data-nav-toggled', 'true')
      }
    } else {
      body.attr('data-nav-toggled', 'true')
    }
  });
  $(document).ready(function () {


    $(".our-partners-slider").slick({
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      speed: 300,
      //nextArrow: '<span class="icon-arrow-right"></span>',
      //prevArrow: '<span class="icon-arrow-left"></span>',
      responsive: [
        {
          breakpoint: 1560,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false,
            infinite: true,
            dots: true
          }
        }
      ]
    });

    $.validator.addMethod("phoneFormat", function(value, element) {
      return this.optional(element) || /^[0-9\s\+\(\)]+$/.test(value);
    }, "Telefonnummernformat");


    /* contact us */
    $("form[name='recall_service']").validate({
      rules: {
        first_name: {
          required: true,
          minlength: 2,
          maxlength: 30,
        },
        phone: {
          required: true,
          minlength: 6,
          maxlength: 21,
          phoneFormat: true
        },
        desirable_time: "required",
      },
      messages: {
        first_name: {
          required: 'Vorname Pflichtfeld',
          minlength: 'Vorname Länge mindestens 2 und maximal 30 Ziffern',
          maxlength: 'Vorname Länge mindestens 2 und maximal 30 Ziffern',
        },
        phone: {
          required: 'Telefonnummer Pflichtfeld',
          minlength: 'Telefonnummer Länge mindestens 6 und maximal 14 Ziffern',
          maxlength: 'Telefonnummer Länge mindestens 6 und maximal 14 Ziffern',
          number: 'Telefonnummernformat'
        },
        desirable_time: 'Wünschenswerte Zeit Pflichtfeld'
      },
      submitHandler: function (form, event) {
        event.preventDefault();

        let formData = new FormData(form);

        axios.post('/recall', formData).then(function (response) {
          const formHtml = $(form).html();

          $(form).html("<div id='message'></div>");
          $('#message').html(`<h2>Ihre Anfrage ist unterwegs!</h2>`)
              .append(`<p>Danke für das Vertrauen</p>`)
              .fadeIn(500)
              .fadeOut(1500);

          setTimeout(function () {
            $(form).html(formHtml);
          }, 2000);
        }).catch(function (response) {

          if (typeof response.response.data.error !== 'undefined' && response.response.status === 422) {
            let error = response.response.data.error;
            $.each(error, function (key, value) {
              $.each(value, function (k, v) {
                let input = $(form).find('input[name="' + key + '"]');

                if (input.parent().find('span[class^="error"]').length > 0) {
                  input.parent().find('span[class^="error"]').remove();
                }

                if (!input.hasClass('error')) {
                  input.addClass('error');
                }

                input.after('<span id="' + key + '-error" class="error invalid-feedback" style="display: block">' + v + '</span>');

                return false;
              });
            });
          }

          if (typeof response.response.data.error !== 'undefined' && response.response.status === 500) {
            $(form).html("<div id='message'></div>");
            $('#message').html(`<h2 style="color: #CD5C5C;">Es tut uns leid. Vorübergehende technische Probleme</h2>`)
                .fadeIn(500)
                .fadeOut(1500);

            setTimeout(function () {
              $(form).html(formHtml);
            }, 2000);
          }
        });
      }
    });

    /* contact form */
    $("form[name='contact-form']").validate({
      rules: {
        first_name: {
          required: true,
          minlength: 2,
          maxlength: 30,
        },
        last_name: {
          minlength: 2,
          maxlength: 30,
        },
        email: {
          required: true,
          email: true
        },
        phone: {
          minlength: 6,
          maxlength: 21,
          phoneFormat: true
        },
      },
      messages: {
        first_name: {
          required: 'Vorname Pflichtfeld',
          minlength: 'Vorname Länge mindestens 2 und maximal 30 Ziffern',
          maxlength: 'Vorname Länge mindestens 2 und maximal 30 Ziffern',
        },
        last_name: {
          required: 'Nachname Pflichtfeld',
          minlength: 'Nachname Länge mindestens 2 und maximal 30 Ziffern',
          maxlength: 'Nachname Länge mindestens 2 und maximal 30 Ziffern',
        },
        company_name: 'Firma Pflichtfeld',
        email: {
          required: 'Email Pflichtfeld',
          email: 'Bitte geben Sie eine gültige E-Mail Adresse ein'
        },
        phone: {
          minlength: 'Telefonnummer Länge mindestens 6 und maximal 14 Ziffern',
          maxlength: 'Telefonnummer Länge mindestens 6 und maximal 14 Ziffern',
          number: 'Telefonnummernformat'
        },
        link: 'Verknüpfung Pflichtfeld',
      },
      submitHandler: function (form, event) {
        event.preventDefault();

        let formData = new FormData(form);

        axios.post('/contact', formData).then(function (response) {
          const formHtml = $(form).html();

          $(form).html("<div id='message'></div>");
          $('#message').html(`<h2>Ihre Anfrage ist unterwegs!</h2>`)
            .append(`<p>Danke für das Vertrauen</p>`)
            .fadeIn(500)
            .fadeOut(1500);

          setTimeout(function () {
            $(form).html(formHtml);
          }, 2000);
        }).catch(function (response) {

          if (typeof response.response.data.error !== 'undefined' && response.response.status === 422) {
            let error = response.response.data.error;
            $.each(error, function (key, value) {
              $.each(value, function (k, v) {
                let input = $(form).find('input[name="' + key + '"]');

                if (input.parent().find('span[class^="error"]').length > 0) {
                  input.parent().find('span[class^="error"]').remove();
                }

                if (!input.hasClass('error')) {
                  input.addClass('error');
                }

                input.after('<span id="' + key + '-error" class="error invalid-feedback" style="display: block">' + v + '</span>');

                return false;
              });
            });
          }

          if (typeof response.response.data.error !== 'undefined' && response.response.status === 500) {
            $(form).html("<div id='message'></div>");
            $('#message').html(`<h2 style="color: #CD5C5C;">Es tut uns leid. Vorübergehende technische Probleme</h2>`)
              .fadeIn(500)
              .fadeOut(1500);

            setTimeout(function () {
              $(form).html(formHtml);
            }, 2000);
          }
        });
      }
    });

    /* credentials slider */
    $(".credentials-product-slider").slick({
      infinite: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 300,
      prevArrow: null,
      nextArrow: null,
      customPaging: function (slider, i) {
        var thumb = $(slider.$slides[i]).data();
        return '<a>' + (i + 1) + '</a>';
      },
      responsive: [
        {
          breakpoint: 1560,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        }
      ]
    });

    $(".chosen-project-slider").slick({
      infinite: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 300,

      prevArrow: null,
      nextArrow: null,
      customPaging: function (slider, i) {
        var thumb = $(slider.$slides[i]).data();
        return '<a>' + (i + 1) + '</a>';
      },
      // customPaging: function (slider, i) {
      //   var thumb = $(slider.$slides[i]).data();
      //   return '<a>' + (i + 1) + '</a>';
      // },
      // responsive: [
      //   {
      //     breakpoint: 1560,
      //     settings: {
      //       slidesToShow: 1,
      //       slidesToScroll: 1,
      //       infinite: true,
      //       dots: false
      //     }
      //   },
      //   {
      //     breakpoint: 1200,
      //     settings: {
      //       slidesToShow: 1,
      //       slidesToScroll: 1,
      //       infinite: true,
      //       dots: false
      //     }
      //   },
      //   {
      //     breakpoint: 992,
      //     settings: {
      //       slidesToShow: 1,
      //       slidesToScroll: 1,
      //       infinite: true,
      //       dots: false
      //     }
      //   },
      //   {
      //     breakpoint: 768,
      //     settings: {
      //       slidesToShow: 1,
      //       slidesToScroll: 1,
      //       infinite: true,
      //       dots: true
      //     }
      //   },
      //   {
      //     breakpoint: 767,
      //     settings: {
      //       slidesToShow: 1,
      //       slidesToScroll: 1,
      //       infinite: true,
      //       dots: false
      //     }
      //   }
      // ]
    });
  });

  $(document).on('input', '.input-phone', function() {
    this.value = this.value.replace(/[^\d\s\(\)\+]/g, '');
    let firstPlusIndex = this.value.indexOf('+');
    if (firstPlusIndex !== -1) {
      this.value = '+' + this.value.replace(/\+/g, '');
    }
  });
})(jQuery);
